export default __webpack_public_path__ + "static/media/hiw-slide-4.83876677.png";